import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>DELEGATION – USING SMART GOALS
                                            </div>
                                            <p>Use this framework to ensure the way you delegate is clear.</p>
                                            <p>‘SMART goals’ is a framework which sets out stages to achieving
                                                goals generally.<a className="superscripttext "
                                                                   href="further_info.php?course=300"><sup>4</sup></a> Use
                                                the same
                                                stages to ensure effective delegating:</p>
                                            <div className="lightgreencontentbg keyquestionpad   ">
                                                <div className="verticalword contentMarginZero"><span
                                                    className="greennumberroundbg CircleAbbr  ">S</span></div>
                                                <span className=" circlediscp ">
    <p><span className="subtiltereg ">pecific</span></p></span>
                                                <ul className="greenbullet-list circleULAlign">
                                                    <li>Clearly set out who and what is involved, and any
                                                        requirements and restrictions.
                                                    </li>
                                                </ul>
                                                <div className="verticalword contentMarginZero"><span
                                                    className="greennumberroundbg CircleAbbr  ">M</span></div>
                                                <span className=" circlediscp ">
    <p><span className="subtiltereg ">easurable</span></p></span>
                                                <ul className="greenbullet-list circleULAlign">
                                                    <li>It’s important to set goals that are ‘measurable’ – that
                                                        means break them
                                                        down into stages to make them more manageable and so
                                                        that you can
                                                        gauge progress.
                                                    </li>
                                                    <li>Ensure that the person you are delegating to understands
                                                        the result that
                                                        is wanted.
                                                    </li>
                                                </ul>
                                                <div className="verticalword contentMarginZero"><span
                                                    className="greennumberroundbg CircleAbbr  ">A</span></div>
                                                <span className=" circlediscp ">
    <p><span className="subtiltereg ">greed upon</span></p></span>
                                                <ul className="greenbullet-list circleULAlign">
                                                    <li>Make sure that you have ‘buy-in’, or commitment, from
                                                        the person to whom
                                                        you delegate.
                                                    </li>
                                                </ul>
                                                <div className="verticalword contentMarginZero"><span
                                                    className="greennumberroundbg CircleAbbr  ">R</span></div>
                                                <span className=" circlediscp ">
    <p><span className="subtiltereg ">ealistic</span></p></span>
                                                <ul className="greenbullet-list circleULAlign">
                                                    <li>Are the necessary resources to complete the task
                                                        available – including time,
                                                        money and knowledge?
                                                    </li>
                                                </ul>
                                                <div className="verticalword contentMarginZero"><span
                                                    className="greennumberroundbg CircleAbbr  ">T</span></div>
                                                <span className=" circlediscp ">
    <p><span className="subtiltereg ">imely</span></p></span>
                                                <ul className="greenbullet-list circleULAlign">
                                                    <li>Always give a time limit. Misunderstandings occur when
                                                        people are asked simply,
                                                        to ‘complete it as soon as possible’ or ‘within a
                                                        reasonable timeframe’.
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>DELEGATION HINTS AND TIPS
                                            </div>
                                            <p>You should ensure that the required standards are clear,
                                                alongside the expected outcomes. This
                                                means gaining agreement on what needs to be done, when by and to
                                                what standard. This will
                                                help ensure that the person you are delegating to has a clear
                                                understanding of what is required
                                                and has the opportunity to ask questions to clarify their
                                                understanding.</p>
                                            <div className="uiheading"><p>Here are some quick reminders of
                                                important things to remember when delegating:</p></div>


                                            <ul className="greenbullet-list">
                                                <li><span className="brown brownbold">Delegate the objective, not the procedure</span> –
                                                    everyone has different working methods, so
                                                    concentrate on the results rather than someone’s methods of
                                                    achieving them.
                                                </li>
                                                <li><span
                                                    className="brown brownbold">Get regular updates</span> –
                                                    these keep everyone aware of progress and provide
                                                    opportunities
                                                    to deal with problems before it’s too late! Set deadlines
                                                    for various stages so that you have
                                                    a timescale.
                                                </li>
                                                <li><span
                                                    className="brown brownbold">Delegate carefully</span> – be
                                                    sure not to repeatedly give the tasks to the most
                                                    experienced or
                                                    first available person. These are not necessarily the most
                                                    appropriate people for the task.
                                                </li>
                                                <li><span className="brown brownbold">Delegate broadly</span> –
                                                    to give people new experiences and training.
                                                </li>
                                                <li><span
                                                    className="brown brownbold">Gain clear feedback</span> – it
                                                    will help you hone your delegating skills!
                                                </li>
                                            </ul>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}